import BExt from '@cap/bext';
// 由于引入了knb，所以需要在knb加载完成后进行初始化
function h5GuardInitWithKNB() {
  BExt.ready(() => {
    Promise.race([
      window.System && window.System.import('https://appsec-mobile.meituan.com/h5guard/H5guard.js'),
      new Promise<void>((resolve) => {
        setTimeout(() => {
          resolve();
        }, 5000); // 5s后未加载，则不再阻塞
      }),
    ]).then(() => {
      window.H5guard &&
        window.H5guard.initWithKey({
          appKey: '2f793186124aebba8f1d2676ec7defe3d87d10dd121e4767b397106a223bb8a9',
          xhrHook: true, // true为开启 false为关闭
          fetchHook: true, // true为开启 false为关闭
          domains: [
            '123.meituan.com',
            '123.cap.st.meituan.com',
            'hz.cap.test.sankuai.com',
            'hao123.meituan.com',
            'hao123.cap.st.meituan.com',
            'hao123.cap.test.sankuai.com',
            'epassport.meituan.com',
            'fepassport.sjst.test.sankuai.com',
            'fepassport.sjst.test.meituan.com',
          ], // 域名白名单配合xhrHook和fetchHook使用，开启之后只会对白名单内的域名请求自动加签，避免出现非业务域名跨域问题
          geo: false, // 如果当前页面有位置权限，则打开开关，H5guard会去收集地理位置信息，如果为false,地理位置默认为“”空字符串
        });
    });
  });
}

export { h5GuardInitWithKNB };
